const axios = require('axios').default;

let translations = {};

const collapseSpaces = (str) => str
  .split('\n')
  .map((l) => l.trim().replace(/\s+/g, ' '))
  .join('\n');

const init = (baseUrl, language) => axios
  .get(`${baseUrl.replace(/\/+$/, '')}/${language}.json`)
  .then((resp) => { translations = resp.data; })
  .catch(() => { translations = {}; })
  .then(() => translations);

const gettext = (str, vars = {}) => {
  const base = collapseSpaces(str);

  return Object
    .keys(vars)
    .reduce(
      (acc, key) => acc.replace(`%{${key}}`, vars[key]),
      translations[base] || base,
    );
};

const ngettext = (str, strPlural, count, vars = {}) => (
  count === 1
    ? gettext(str, vars)
    : gettext(strPlural, { count, ...vars })
);

module.exports = { init, gettext, ngettext };
